import { ChangeDetectionStrategy, Component, DestroyRef, OnInit, Signal, computed, inject, input, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import {
    CasinoLobbyService,
    Categories,
    CategoryInfo,
    FavouriteService,
    RecentGamesService,
    UnfinishedGamesService,
} from '@casinocore/platform/core';
import { UserService } from '@frontend/vanilla/core';
import { Subscription } from 'rxjs';

import { RpFavToggleWidgetComponent } from '../rp-fav-toggle-widget/rp-fav-toggle-widget.component';

@Component({
    selector: 'cc-rp-fav-toggle-section',
    templateUrl: 'rp-fav-toggle-section.component.html',
    imports: [RpFavToggleWidgetComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class RPFavToggleSectionComponent implements OnInit {
    lobbyType = input<string>('');
    gameContainer = input<string>('');
    category = input<CategoryInfo>({} as CategoryInfo);
    isTouch = input<boolean>(false);
    headerClass = input<string>('');

    recentObs: Subscription = new Subscription();
    favObs: Subscription = new Subscription();
    protected casinoLobbyService = inject(CasinoLobbyService);
    protected recentGameService = inject(RecentGamesService);
    protected unfinishedGamesService = inject(UnfinishedGamesService);
    protected favouriteService = inject(FavouriteService);
    protected userService = inject(UserService);

    isAuthenticated = signal(false);
    favGames = signal<string[]>([]);
    recentGames = signal<string[]>([]);
    currentCategoryInfo: Signal<Categories> = computed(() => this.category().categoryInfo);
    categoryId = computed(() => this.currentCategoryInfo().categoryid);
    showWidget = computed(() => this.favGames().length + this.recentGames().length > 0);
    destroyRef = inject(DestroyRef);

    constructor() {}

    ngOnInit(): void {
        this.isAuthenticated.set(this.userService.isAuthenticated);
        this.favObs = this.favouriteService.favouriteGamesFeedObservable.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((games: string[]) => {
            if (!games) return;
            this.favGames.set([...games].reverse());
        });

        this.recentObs.add(
            this.unfinishedGamesService.unfinishedFeedObservable.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((games: string[]) => {
                if (!games) return;
                this.setRecentGames(games, this.recentGameService.getrecentGames());
            }),
        );

        this.recentObs.add(
            this.recentGameService.recentGamesFeedObservable.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((games: string[]) => {
                if (!games) return;
                this.setRecentGames(this.unfinishedGamesService.getUnfinishedGames(), games);
            }),
        );
    }

    private setRecentGames(unfinishedGames: string[], recentGames: string[]): void {
        this.recentGames.set([...unfinishedGames, ...recentGames]);
    }
}
